var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-content"},[_c('div',{staticClass:"box",style:({
      'width': `${_vm.width}px`,
      'height': `${_vm.height}px`,
      transform: `scale(${_vm.scalseNum})`,
      '-webkit-transform': `scale(${_vm.scalseNum})`,
      '-moz-transform': `scale(${_vm.scalseNum})`,
      '-o-transform': `scale(${_vm.scalseNum})`,
      '-ms-transform': `scale(${_vm.scalseNum})`,
    })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }